import React from 'react';
import PropTypes from 'prop-types';

import Flyout from './Flyout/FlyoutController';
import NavLink from './NavLink/NavLink';
import SearchForm from './SearchForm/SearchForm';

// import assets
import Logo from '../../../../assets/images/ZEISS_Brand_CMYK.svg';
import '../../../../assets/icons/Logo_Lenspire_Photo.svg';
import './headerMobile.scss';


const HeaderMobileView = props => (
  <div
    className={`m-header-wrapper ${props.pinned ? 'm-header-wrapper--pinned' : ''} ${props.unpinned ? 'm-header-wrapper--unpinned' : ''} ${props.unfixed ? 'm-header-wrapper--unfixed' : ''} ${props.scrolled ? 'm-header-wrapper--scrolled' : ''} ${props.flyoutVisible ? 'm-header-wrapper--enableOverflow' : ''}`}
  >
    <div className={'m-header--mobile'}>
      <div className={'m-header__upper'}>
        <div className={'m-header__logo'} onClick={props.goHome} role={'link'} tabIndex={-1}>
          <img src={Logo} alt="Zeiss Logo" />
        </div>
        <div className={'m-header__title'}>
          <svg>
            <use xlinkHref="#Logo_Lenspire_Photo" />
          </svg>
        </div>
        <div className={'m-header__burger'} onClick={props.toggleFlyout} tabIndex={0} role="button">
          {
            props.flyoutVisible ?
              (<svg>
                <use xlinkHref={'#Lenspire_Icon_CloseGlobal'} />
              </svg>) :
              (<div>
                <div className={'m-header__burgerline'} />
                <div className={'m-header__burgerline'} />
              </div>)
          }
        </div>
      </div>
      <div className={props.flyoutVisible ? 'm-header__lower m-header__lower--visible' : 'm-header__lower'}>
        <div className={'m-header__nav'}>
          <ul>
            {Object.keys(props.categories).map(category => (
              <NavLink
                key={category}
                category={props.categories[category]}
                openFlyout={props.openFlyout}
                toggleFlyout={props.toggleFlyout}
                flyoutVisible={props.flyoutVisible}
                setHashByActiveSubCategories={props.setHashByActiveSubCategories}
              />
            ))}
          </ul>
        </div>
      </div>
      {(() => {
        if (!props.activeCategory.directFilter) {
          return (<Flyout
            visible={props.flyoutVisible}
            closeFlyout={props.closeFlyout}
            setHashByActiveSubCategories={props.setHashByActiveSubCategories}
            mobile
          />);
        }
        return null;
      })()}
      <SearchForm visible={props.flyoutVisible} />
    </div>
  </div>
);

HeaderMobileView.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.shape,
        title: PropTypes.string,
      })),
    }),
  ),
  activeCategory: PropTypes.shape(),
  flyoutVisible: PropTypes.bool,
  toggleFlyout: PropTypes.func,
  openFlyout: PropTypes.func,
  unfixed: PropTypes.bool,
  scrolled: PropTypes.bool,
  pinned: PropTypes.bool,
  unpinned: PropTypes.bool,
  goHome: PropTypes.func.isRequired,
  setHashByActiveSubCategories: PropTypes.func.isRequired,
};

HeaderMobileView.defaultProps = {
  categories: [],
  activeCategory: {},
  flyoutVisible: false,
  unfixed: true,
  scrolled: false,
  pinned: false,
  unpinned: false,
  toggleFlyout: () => {
  },
  openFlyout: () => {
  },
};

export default HeaderMobileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/HeaderMobileView.jsx